import React from "react";

export default function Logo() {
  const logo =  process.env.PUBLIC_URL+'/logo.svg';
  return (
    <div itemProp="brand" itemScope itemType="https://schema.org/Brand" className="icon-top-left">
        <div className="tm-box">
            <img itemProp="logo" src={logo} className="icon" id="topleft-icon" alt="plannt logo" width="41px" height="64px"/>
            <span className="TM">TM</span>
        </div>
        <div className="tm-box">
            <h1 itemProp="name" className="logo-text-home">plannt.ca</h1>
        </div>
    </div>
  );
};
